import type { ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger'
type Size = 'md' | 'sm' | 'icon'

const VARIANTS: Record<Variant, string> = {
  primary: 'bg-accent text-accent-fg hover:opacity-90',
  secondary: 'bg-surface text-fg ring-1 ring-inset ring-line hover:bg-line/60',
  ghost: 'text-fg hover:bg-surface',
  danger: 'bg-danger text-white hover:opacity-90',
}

// На телефоне цели 44px, на компьютере плотнее.
const SIZES: Record<Size, string> = {
  md: 'h-11 px-4 text-[15px] desk:h-8 desk:px-3 desk:text-[13px]',
  sm: 'h-11 px-3 text-sm desk:h-7 desk:px-2.5 desk:text-xs',
  icon: 'size-11 desk:size-8',
}

export function buttonClass(variant: Variant = 'secondary', size: Size = 'md', extra = ''): string {
  return [
    'inline-flex shrink-0 select-none items-center justify-center gap-2 whitespace-nowrap rounded-lg font-medium',
    'transition-[background-color,opacity] disabled:pointer-events-none disabled:opacity-50',
    VARIANTS[variant],
    SIZES[size],
    extra,
  ].join(' ')
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: Size
}

export function Button({ variant, size, className = '', type = 'button', ...rest }: ButtonProps) {
  return <button type={type} className={buttonClass(variant, size, className)} {...rest} />
}
